import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap');
    
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        outline: 0;
        font-family: 'Poppins', sans-serif;
    }

    button {
        cursor: pointer;
        transition: transform 0.2s ease;

        &:hover {
            transform: scale(1.01);
        }
    }

    a {
        text-decoration: none;
        color: #000;
    }
`
